import { SERVICE_TYPE } from "../../../../../../shared/constants/system-default-data-constant";

export interface IServiceCode {
  serviceCodeId: string;
  code: string;
  descriptionEnglish: string;
  descriptionArabic: string;
  grossPrice: number;
  discountinPercentage: number;
  serviceTypeId: string;
  serviceTypeNameEnglish: string;
  serviceTypeNameArabic: string;
  standardNameId: string;
  standardNameEnglish: string;
  standardNameArabic: string;
  discontinueDate: Date;
  granularUnit: number;
  unitType: string;
  unitTypeNameEnglish: string;
  unitTypeNameArabic: string;
  packageType: string;
  packageTypeNameEnglish: string;
  packageTypeNameArabic: string;
  packageSize: number;
  scientificCode: string;
  scientificNameEnglish: string;
  scientificNameArabic: string;
  strength: string;
  strengthUnit: string;
  pharmaceuticalForm: string;
  pharmaceuticalFormCode: string;
  pharmaceuticalFormDescriptionEnglish: string;
  pharmaceuticalFormDescriptionArabic: string;
  scientificMedicationCodeDetails: ScientificMedicationCodeDetails[];
  display: string;
  categoryId: string;
  categoryNameEnglish: string;
  categoryNameArabic: string;
  manufacturer: string;
  regOwner: string;
  dosageFormId: string;
  dosageFormNameEnglish: string;
  dosageFormNameArabic: string;
  roaId: string;
  roaNameEnglish: string;
  roaNameArabic: string;
  ingredients: string;
  releaseDate: Date;
  receivedDate: Date;
  otherCodesType: string;
  otherCodesValue: string;
  medicationScientificCodeId: string;
  medicationScientificCode: string;
  medicationScientificStrength: string;
  medicationScientificPharmFormCode: string;
  additionalDosageForms: AdditionalDosageForm[];
  additionalRoas: AdditionalRoa[];
  createdDate?: string;
}

interface AdditionalDosageForm {
  dosageFormId: string;
}

interface AdditionalRoa {
  roaId: string;
}

interface ScientificMedicationCodeDetails {
  scientificmedicationcodedetailid: string;
  serviceCodeId: string;
  code: string;
  descriptionEnglish: string;
  descriptionArabic: string;
}

export const serviceCodeConfig = {
  entityName: 'CONFIGURATION.SERVICE_CODE.TITLE',
  code: 'FORM_FIELD.CODE',
  englishDesription: 'FORM_FIELD.ENGLISH_DESCRIPTION',
  arabicDesription: 'FORM_FIELD.ARABIC_DESCRIPTION',
  grossPrice: 'FORM_FIELD.GROSS_PRICE',
  discountInPercentage: 'CONFIGURATION.SERVICE_CODE.DISCOUNT_IN_PERCENTAGE',
  servieType: 'CONFIGURATION.SERVICE_TYPE.TITLE',
  standardName: 'CONFIGURATION.MASTER_DATA.STANDARD_NAME.TITLE',
  discontiueDate: 'FORM_FIELD.DISCONTINUE_DATE',
  scientificCode: 'CONFIGURATION.DRUGCODE.SCIENTIFIC_CODE',
  scientificNameEnglish: 'CONFIGURATION.SERVICE_CODE.SCIENTIFIC_NAME_ENGLISH',
  scientificNameArabic: 'CONFIGURATION.SERVICE_CODE.SCIENTIFIC_NAME_ARABIC',
  strengthUnit: 'CONFIGURATION.SERVICE_CODE.STRENGTH_UNIT',
  pharmaceuticalForm: 'CONFIGURATION.PHARMACEUTICAL_FORM.TITLE',
  display: 'FORM_FIELD.DISPLAY',
  categoryId: 'COMMON.CATEGORY',
  price: 'COMMON.PRICE',
  manufacturer: 'FORM_FIELD.MANUFACTURER',
  regOwner: 'FORM_FIELD.REG_OWNER',
  dosageFormId: 'FORM_FIELD.DOSAGE_FORM',
  roaId: 'FORM_FIELD.REG_OWNER',
  ingredients: 'FORM_FIELD.INGREDIENTS',
  releaseDate: 'FORM_FIELD.RELEASE_DATE',
  receivedDate: 'FORM_FIELD.RECEIVED_DATE',
  otherCodesType: 'FORM_FIELD.OTHER_CODES_TYPE',
  otherCodesValue: 'FORM_FIELD.OTHER_CODES_VALUE',
  medicationScientificCodeId: 'CONFIGURATION.DRUGCODE.SCIENTIFIC_CODE',
  granularUnit: 'FORM_FIELD.GRANULAR_UNIT',
  strength: 'FORM_FIELD.STRENGTH',
  packageSize: 'FORM_FIELD.PACKAGE_SIZE',
  unitType: 'FORM_FIELD.UNIT_TYPE',
  packageType: 'FORM_FIELD.PACKAGE_FORM',
  discontinueDate: 'FORM_FIELD.DISCONTINUE_DATE',
};

export const SERVICE_TYPE_FIELD_MAP = {
  [SERVICE_TYPE.SCIENTIFIC_CODES]: { fields: ['scientificCode'], separator: '' },
};

export const DEFAULT_SERVICE_TYPE_CONFIG = {
  fields: ['code'],
  separator: '',
};